// ---------------------------------------------------------------------------------------------------------------------
export function stackTrace() {
  var err = new Error();
  return err.stack;
}